import { ArrayWrap } from "@/mixins";
import { TagType } from "@/models/tag-type";

class Role {
  roleType: RoleCode;
  name: string;
  nameRus: string;
  displayType: TagType;
  constructor(roleType: RoleCode, name: string, nameRus: string, displayType: TagType) {
    this.roleType = roleType;
    this.name = name;
    this.nameRus = nameRus;
    this.displayType = displayType;
  }
}

export enum RoleCode {
  ADMINISTRATION_WRITE_INTERNAL = "UWSCC_ADMINISTRATION_WRITE_INTERNAL",
  ADMINISTRATION_READ_INTERNAL = "UWSCC_ADMINISTRATION_READ_INTERNAL",
  SLY_SHOPPING_WRITE_INTERNAL = "UWSCC_SLY_SHOPPING_WRITE_INTERNAL",
  SLY_SHOPPING_READ = "UWSCC_SLY_SHOPPING_READ",
  PRODUCTS_READ = "UWSCC_PRODUCTS_READ",
  COUPON_CHECK_READ = "UWSCC_COUPON_CHECK_READ",
  PURCHASE_HISTORY_READ = "UWSCC_PURCHASE_HISTORY_READ",
  RUBLE_BALANCE_READ = "UWSCC_RUBLE_BALANCE_READ",
  SEND_GUEST_CARD_READ = "UWSCC_SEND_GUEST_CARD_READ",
  COUPON_MAPPING_WRITE_INTERNAL = "UWSCC_COUPON_MAPPING_WRITE_INTERNAL",
  MANUAL_BONUS_CALC_WRITE_INTERNAL = "UWSCC_MANUAL_BONUS_CALC_WRITE_INTERNAL",
  PHONE_UNMAP_READ = "UWSCC_PHONE_UNMAP_READ",
  METROPOLIS_WRITE_INTERNAL = "UWSCC_METROPOLIS_WRITE_INTERNAL",
  METROPOLIS_READ = "UWSCC_METROPOLIS_READ",
  EMAIL_CONFIRMATION_READ = "UWSCC_EMAIL_CONFIRMATION_READ",
  FILE_STORAGE_WRITE_INTERNAL = "UWSCC_FILE_STORAGE_WRITE_INTERNAL",
  FILE_STORAGE_READ = "UWSCC_FILE_STORAGE_READ",
  CALLS_WRITE_INTERNAL = "UWSCC_CALLS_WRITE_INTERNAL",
  REPL_CARD_IN_MSG_WRITE = "UWSCC_REPL_CARD_IN_MSG_WRITE",
  CLIENTS_WRITE_INTERNAL = "UWSCC_CLIENTS_WRITE_INTERNAL",
  CLIENTS_UNBLOCK_4_9_WRITE = "UWSCC_CLIENTS_UNBLOCK_4_9_WRITE",
  CLIENTS_READ = "UWSCC_CLIENTS_READ",
  INVITATIONS_READ = "UWSCC_INVITATIONS_READ",
  CASHBACK_READ = "UWSCC_CASHBACK_READ",
  FRAUD_WRITE_INTERNAL = "UWSCC_FRAUD_WRITE_INTERNAL",
  FRAUD_READ_INTERNAL = "UWSCC_FRAUD_READ_INTERNAL",
  RELATIVES_WRITE = "UWSCC_RELATIVES_WRITE",
  RELATIVES_READ = "UWSCC_RELATIVES_READ",
  M_SHOP_READ_INTERNAL = "UWSCC_M_SHOP_READ_INTERNAL",
  BASE_WRITE_INTERNAL = "UWSCC_BASE_WRITE_INTERNAL",
  BASE_READ = "UWSCC_BASE_READ",
  DELIVERY_ADMIN_READ = "UWSCC_DELIVERY_ADMIN_READ",
  PROMOCODES_WRITE_INTERNAL = "UWSCC_PROMOCODES_WRITE_INTERNAL",
  PROMOCODES_READ = "UWSCC_PROMOCODES_READ",
  METRO_BONUS_READ = "UWSCC_METRO_BONUS_READ",
  METRO_BONUS_WRITE_INTERNAL = "UWSCC_METRO_BONUS_WRITE_INTERNAL",
  CRM_MECHANICS_WRITE_INTERNAL = "UWSCC_CRM_MECHANICS_WRITE_INTERNAL",
  ALCOGURU_WRITE_INTERNAL = "UWSCC_ALCOGURU_WRITE_INTERNAL",
  ALCOGURU_READ = "UWSCC_ALCOGURU_READ",
  PERS_DATA_ACCESS_READ_INTERNAL = "UWSCC_PERS_DATA_ACCESS_READ_INTERNAL",
  USER_LOGIN_READ = "UWSCC_USER_LOGIN_READ",
  COMMUNICATION_HISTORY_READ = "UWSCC_COMMUNICATION_HISTORY_READ",
}

export const RolesByEnum: ArrayWrap<Role> = {
  [RoleCode.ADMINISTRATION_WRITE_INTERNAL]: new Role(
    RoleCode.ADMINISTRATION_WRITE_INTERNAL,
    "Administration write internal",
    "Администрирование запись внутренний",
    ""
  ),
  [RoleCode.ADMINISTRATION_READ_INTERNAL]: new Role(
    RoleCode.ADMINISTRATION_READ_INTERNAL,
    "Administration internal",
    "Администрирование внутренний",
    "success"
  ),
  [RoleCode.SLY_SHOPPING_WRITE_INTERNAL]: new Role(
    RoleCode.SLY_SHOPPING_WRITE_INTERNAL,
    "Sly Shopping write internal",
    "Хитрошопинг запись внутренний",
    ""
  ),
  [RoleCode.SLY_SHOPPING_READ]: new Role(
    RoleCode.SLY_SHOPPING_READ,
    "Sly Shopping",
    "Хитрошопинг",
    "warning"
  ),
  [RoleCode.PRODUCTS_READ]: new Role(RoleCode.PRODUCTS_READ, "Products Search", "Поиск товара", "warning"),
  [RoleCode.COUPON_CHECK_READ]: new Role(
    RoleCode.COUPON_CHECK_READ,
    "Coupon Check",
    "Проверка и отправка купонов",
    "warning"
  ),
  [RoleCode.PURCHASE_HISTORY_READ]: new Role(
    RoleCode.PURCHASE_HISTORY_READ,
    "Purchase History",
    "История покупок клиента",
    "warning"
  ),
  [RoleCode.RUBLE_BALANCE_READ]: new Role(
    RoleCode.RUBLE_BALANCE_READ,
    "Ruble Balance",
    "Проверка баланса бонусных рублей",
    "warning"
  ),
  [RoleCode.SEND_GUEST_CARD_READ]: new Role(
    RoleCode.SEND_GUEST_CARD_READ,
    "Send Guest Card",
    "Отправка карты гостя",
    "warning"
  ),
  [RoleCode.COUPON_MAPPING_WRITE_INTERNAL]: new Role(
    RoleCode.COUPON_MAPPING_WRITE_INTERNAL,
    "Coupon Mapping write internal",
    "Привязка/отвязка купонов запись внутренний",
    ""
  ),
  [RoleCode.MANUAL_BONUS_CALC_WRITE_INTERNAL]: new Role(
    RoleCode.MANUAL_BONUS_CALC_WRITE_INTERNAL,
    "Manual Bonus Calculation write internal",
    "Начисление и списание бонусов запись внутренний",
    ""
  ),
  [RoleCode.PHONE_UNMAP_READ]: new Role(
    RoleCode.PHONE_UNMAP_READ,
    "Phone Unmap",
    "Разбивка связи 'Телефон - номер карты'",
    "warning"
  ),
  [RoleCode.METROPOLIS_WRITE_INTERNAL]: new Role(
    RoleCode.METROPOLIS_WRITE_INTERNAL,
    "Metropolis write internal",
    "Метрополия запись внутренний",
    ""
  ),
  [RoleCode.METROPOLIS_READ]: new Role(RoleCode.METROPOLIS_READ, "Metropolis", "Метрополия", "warning"),
  [RoleCode.EMAIL_CONFIRMATION_READ]: new Role(
    RoleCode.EMAIL_CONFIRMATION_READ,
    "Email Confirmation",
    "Подтверждение EmaIl",
    "warning"
  ),
  [RoleCode.FILE_STORAGE_WRITE_INTERNAL]: new Role(
    RoleCode.FILE_STORAGE_WRITE_INTERNAL,
    "File Storage write internal",
    "Файловое хранилище запись внутренний",
    ""
  ),
  [RoleCode.FILE_STORAGE_READ]: new Role(
    RoleCode.FILE_STORAGE_READ,
    "File Storage",
    "Файловое хранилище",
    "warning"
  ),
  [RoleCode.CALLS_WRITE_INTERNAL]: new Role(
    RoleCode.CALLS_WRITE_INTERNAL,
    "Calls write internal",
    "Обзвон запись внутренний",
    ""
  ),
  [RoleCode.REPL_CARD_IN_MSG_WRITE]: new Role(
    RoleCode.REPL_CARD_IN_MSG_WRITE,
    "Replace Card in Messenger write",
    "Замена карты клиента в Viber и Телеграмм бот запись",
    "danger"
  ),
  [RoleCode.CLIENTS_WRITE_INTERNAL]: new Role(
    RoleCode.CLIENTS_WRITE_INTERNAL,
    "Clients write internal",
    "CFM запись внутренний",
    ""
  ),
  [RoleCode.CLIENTS_UNBLOCK_4_9_WRITE]: new Role(
    RoleCode.CLIENTS_UNBLOCK_4_9_WRITE,
    "Clients unblock 4, 9 write",
    "CFM снятие блокировок 4 и 9 запись",
    ""
  ),
  [RoleCode.CLIENTS_READ]: new Role(RoleCode.CLIENTS_READ, "Clients", "CFM", "warning"),
  [RoleCode.INVITATIONS_READ]: new Role(
    RoleCode.INVITATIONS_READ,
    "Invitations",
    "Список приглашенных друзей",
    "warning"
  ),
  [RoleCode.CASHBACK_READ]: new Role(RoleCode.CASHBACK_READ, "Cashback", "Кэшбэк за клик", "warning"),
  [RoleCode.FRAUD_WRITE_INTERNAL]: new Role(
    RoleCode.FRAUD_WRITE_INTERNAL,
    "Fraud write internal",
    "FRAUD запись внутренний",
    ""
  ),
  [RoleCode.FRAUD_READ_INTERNAL]: new Role(
    RoleCode.FRAUD_READ_INTERNAL,
    "Fraud internal",
    "FRAUD внутренний",
    "success"
  ),
  [RoleCode.RELATIVES_WRITE]: new Role(
    RoleCode.RELATIVES_WRITE,
    "Relatives write",
    "Родственники запись",
    "danger"
  ),
  [RoleCode.RELATIVES_READ]: new Role(RoleCode.RELATIVES_READ, "Relatives", "Родственники", "warning"),
  [RoleCode.M_SHOP_READ_INTERNAL]: new Role(
    RoleCode.M_SHOP_READ_INTERNAL,
    "MShop internal",
    "MShop внутренний",
    "success"
  ),
  [RoleCode.BASE_WRITE_INTERNAL]: new Role(
    RoleCode.BASE_WRITE_INTERNAL,
    "Base write internal",
    "Базы запись внутренний",
    ""
  ),
  [RoleCode.BASE_READ]: new Role(RoleCode.BASE_READ, "Base", "Базы", "warning"),
  [RoleCode.DELIVERY_ADMIN_READ]: new Role(
    RoleCode.DELIVERY_ADMIN_READ,
    "Delivery Admin",
    "Админка заказов",
    "warning"
  ),
  [RoleCode.PROMOCODES_WRITE_INTERNAL]: new Role(
    RoleCode.PROMOCODES_WRITE_INTERNAL,
    "Promocodes write internal",
    "Промокоды запись внутренний",
    ""
  ),
  [RoleCode.PROMOCODES_READ]: new Role(RoleCode.PROMOCODES_READ, "Promocodes", "Промокоды", "warning"),
  [RoleCode.METRO_BONUS_READ]: new Role(RoleCode.METRO_BONUS_READ, "Metro Bonus", "Метро бонус", "warning"),
  [RoleCode.METRO_BONUS_WRITE_INTERNAL]: new Role(
    RoleCode.METRO_BONUS_WRITE_INTERNAL,
    "Metro Bonus write internal",
    "Метро бонус запись внутренний",
    ""
  ),
  [RoleCode.CRM_MECHANICS_WRITE_INTERNAL]: new Role(
    RoleCode.CRM_MECHANICS_WRITE_INTERNAL,
    "CRM Mechanics write internal",
    "CRM механики запись внутренний",
    ""
  ),
  [RoleCode.ALCOGURU_WRITE_INTERNAL]: new Role(
    RoleCode.ALCOGURU_WRITE_INTERNAL,
    "Alcoguru write internal",
    "Алкогуру запись внутренний",
    ""
  ),
  [RoleCode.ALCOGURU_READ]: new Role(RoleCode.ALCOGURU_READ, "Alcoguru", "Алкогуру", "warning"),
  [RoleCode.USER_LOGIN_READ]: new Role(RoleCode.USER_LOGIN_READ, "Login", "Вход", "info"),
  [RoleCode.PERS_DATA_ACCESS_READ_INTERNAL]: new Role(
    RoleCode.PERS_DATA_ACCESS_READ_INTERNAL,
    "Personal data access",
    "Доступ к ПД",
    "info"
  ),
  [RoleCode.COMMUNICATION_HISTORY_READ]: new Role(
    RoleCode.COMMUNICATION_HISTORY_READ,
    "Communication history",
    "История рассылки",
    ""
  ),
};
